import React from "react"
import { sanitizer } from "@commonUtils"
import PrimaryButton from "@components/Experiments/vsat/PrimaryButton"

import css from "./HeroSection.scss"
const headerOffest = 100

const HeroSection = ({ data }) => {
    return (
        <section className={`${css.pageContainer} flex positionRelative`}>
            <picture>
                <source media="(max-width: 767px)" srcSet={data.backgroundImageMweb.url} />
                <source media="(min-width: 768px)" srcSet={data.backgroundImageDweb.url} />
                <img
                    className={css.heroBg}
                    srcSet={data.backgroundImageDweb.url}
                    alt="a head carved out of wood"
                />
            </picture>
            <div className="container-fluid flex page-container positionRelative">
                <div
                    className={`flexColumn ${
                        data.isLeftAligned ? "" : "alignCenter marginAuto"
                    }  justifyCenter`}
                >
                    <h1
                        className={`heroHeader ${data.isLeftAligned ? "" : "textCenter"} col-16`}
                        dangerouslySetInnerHTML={{
                            __html: sanitizer(data.header),
                        }}
                    />
                    <h2
                        className={`headingLargeMedium padding-40-0 ${
                            data.isLeftAligned ? "" : "textCenter"
                        } heroSubheader col-14`}
                        dangerouslySetInnerHTML={{
                            __html: sanitizer(data.subHeader),
                        }}
                    />
                    {data.cta && (
                        <div className="col-8 marginTop-32 mx-mobile-24">
                            <PrimaryButton
                                theme="black"
                                label={data.cta.label}
                                labelClass={css.buttonLabel}
                                onClick={() => {
                                    const scrollDiv = document.getElementById("supportSection").offsetTop
                                    window.scrollTo({ top: scrollDiv - headerOffest, behavior: "smooth" })
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
}

export default HeroSection
